import { useContext } from 'react';

import { HeadlessContext } from '~/context';

export const useHeadless = () => useContext(HeadlessContext);
